import React from 'react';

export default () => (
  <div className="flex-center p-50">
    <h3 className="color-danger">Something went wrong, please close the window and reopen again.</h3>
  </div>
);
